import { css } from "@emotion/core";
import { fontSizes, color, fontTypes, fontWeight } from "../constants/commons";

export const responsiveStyles = css`
  .page-margin-container {
    margin: 5.5em 0 0 0;
  }

  .responsive-error-asterix-style{
    font-size: ${fontSizes.xxlg};
    padding-bottom: -10em;
    margin: -0.3em 0 0 0;
  }
  .error-text {
    color: ${color.red};
  }
  .small-text{
    font-size: ${fontSizes.xxs}
  }
  .bg-none {
    background: none;
  }

  .css-yk16xz-control{
    border-bottom: 1px solid;
    border-top: none;
    border-left: none;
    border-right: none;
    background: none;
  }

  // Styling for the OptionField component from Pandora
  .option-field-container .option-select-container .react-select__control {
    border-bottom: 1px solid;
    border-top: none;
    border-left: none;
    border-right: none;
    background: none;
  }
  .option-field-container .option-select-container .react-select__placeholder {
    font-size: ${fontSizes.xs};
    color: ${color.lightishGray};
  }
  // Styling for the OptionField component from Pandora
  .css-1okebmr-indicatorSeparator {
    display: none;
  }
  // Styling for the OptionField component from Pandora
  .css-tlfecz-indicatorContainer {
    color: ${color.black};
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .responsive-font-body {
      font-size: ${fontSizes.xxs};
    }
    .resposnive-container-margin {
      margin 1.5em 0 4em 0
    }
    .responsive-text {
      font-size: ${fontSizes.xxs};
      font-weight: ${fontWeight.light};
      text-align: center;
      text-transform: uppercase;
    }
    .responsive-button-width {
      width: 15em;
    }
    .responsive-prelogin-modal {
      max-width: 100%;
      margin: 0;
      height: 100%;
    }
    .opt-message {
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.xxs};
      color: ${color.lightishGray};
      margin: -1.5em 0 2em 0;
      position: relative;
      bottom: 0.6em;
    }
    .message-style {
      color: ${color.lightishGray};
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.xs};
    }
    .relative-position {
      position: relative;
      min-height: 44em;
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .resposnive-container-margin {
      margin 1.5em 0 4em 0
    }
    .responsive-font-body {
      font-size: ${fontSizes.xxs};
    }
    .responsive-text {
      font-size: ${fontSizes.xxs};
      font-weight: ${fontWeight.light};
      text-align: center;
      text-transform: uppercase;
    }
    .responsive-button-width {
      width: 9em;
    }
    .opt-message {
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.xxs};
      color: ${color.lightishGray};
      margin: -1.5em 0 2em 0;
      position: relative;
      bottom: 0.6em;
    }
    .message-style {
      color: ${color.lightishGray};
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.xs};
    }
    .variable-margin-style {
      margin: 5.5em 0 0 0;
    }
    .relative-position {
      position: relative;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .resposnive-container-margin {
      margin 1.5em 0 6em 0
    }
    .responsive-font-body {
      font-size: ${fontSizes.sm};
    }
    .responsive-text {
      font-size: ${fontSizes.xxs};
      font-weight: ${fontWeight.light};
      text-align: center;
      text-transform: uppercase;
    }
    .responsive-button-width {
      width: 12em;
    }
    .opt-message {
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.xxs};
      color: ${color.lightishGray};
      margin: -1.5em 0 2em 0;
      position: relative;
      bottom: 0.6em;
    }
    .message-style {
      color: ${color.lightishGray};
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.sm};
    }
    .variable-margin-style {
      margin: 5.5em 0 0 0;
    }
    .relative-position {
      position: relative;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .resposnive-container-margin {
      margin 1.5em 0 6em 0
    }
    .responsive-font-body {
      font-size: ${fontSizes.sm};
    }
    .message-style {
      color: ${color.lightishGray};
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.sm};
    }
    .responsive-text {
      font-size: ${fontSizes.xxs};
      font-weight: ${fontWeight.light};
      text-align: center;
      text-transform: uppercase;
    }
    .responsive-button-width {
      width: 12em;
    }
    .variable-margin-style {
      margin: 5.5em 0 0 0;
    }
    .opt-message {
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.xxs};
      color: ${color.lightishGray};
      margin: 0em 0em 5em 0;
      position: relative;
      bottom: 1.6em;
    }
    .relative-position {
      position: relative;
      padding-left: 2em;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .resposnive-container-margin {
      margin 1.5em 0 6em 0
    }
    .responsive-font-body {
      font-size: ${fontSizes.sm};
    }
    .message-style {
      color: ${color.lightishGray};
      font-weight: ${fontWeight.medium};
    }
    .responsive-text {
      font-size: ${fontSizes.xs};
      font-weight: ${fontWeight.light};
      text-align: center;
      text-transform: uppercase;
    }
    .responsive-button-width {
      width: 12em;
    }
    .variable-margin-style {
      margin: 2.6em 0 0 0;
    }
    .opt-message {
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.xxs};
      color: ${color.lightishGray};
      margin: 0.5em 0;
      position: relative;
      bottom: 1.6em;
    }
    .relative-position {
      position: relative;
    }
  }

  .short-description-style {
    color: ${color.lightishGray};
    font-family: ${fontTypes.bodyFont};
    font-size: ${fontSizes.xs};
  }

  .button-style-red {
    background: ${color.red};
    border-radius: 1.56em;
    box-shadow: 0 0.025em 0.0625em 0 ${color.black};
    color: ${color.white};
    height: 2.75em;
    border: none;
    text-transform: uppercase;
    font-family: ${fontTypes.bold};
    box-shadow: ${color.buttonShadow};
  }
  .button-style-white {
    background: ${color.white};
    border-radius: 1.56em;
    font-family: ${fontTypes.bold};
    color: ${color.black};
    box-shadow: ${color.buttonShadow};
    height: 2.75em;
    border: none;
    text-transform: uppercase;
  }
  .edit-button-style {
    color: ${color.red};
    font-type: ${fontTypes.bold};
  }
  .resend-button-style {
    color: ${color.black};
    font-type: ${fontTypes.bold};
  }
  .resend-button-style:disabled {
    color: ${color.borderGreen};
    font-type: ${fontTypes.bold};
  }
  .user-button-style:hover,
  .user-button-style:active,
  .user-button-style:active:focus,
  .user-button-style:visited,
  .user-button-style:focus {
    outline: none;
    text-decoration: none;
  }
  .user-button-style:disabled,
  .user-button-style[disabled] {
    background: ${color.disbaledShadow};
    border-radius: 1.57em;
    cursor: not-allowed;
  }
  .user-button-style {
    cursor: pointer;
  }
  .wifi-button {
    background: ${color.white};
    border-radius: 0.25em;
    border: 1px solid ${color.darkRed};
    border-style: dotted;
  }
  .selected-link {
    font-weight: ${fontWeight.bold};
    color: ${color.red};
  }
  .status-background {
    background: ${color.whitishGray};
    border-radius: 0em;

    box-shadow: none;
    /* Extra small devices (portrait phones, less than 576px) */
    @media (max-width: 575.98px) {
      padding-bottom: 4em !important;
    }
    /* Extra large devices (large desktops, 1200px and up) */
    @media (min-width: 1200px) {
      min-height: 100vh;
    }
  }
`;

export const inlineBorderStyle = {
  borderTop: "none",
  borderLeft: "none",
  borderRight: "none",
};

export const singleSectionStyles = (backgroundColor?: string) => css`
  ${backgroundColor && `background-color: ${backgroundColor};`}
  .back-button {
    margin-right: 0.5em;
  }
  .back-button-style {
    color: ${color.red};
    height: 1.35em;
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    padding: 1em;
    .back-button-margin {
      margin-top: 5em;
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    padding: 1em;
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    padding: 2em 2.5em;
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    padding: 4em 6em;
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    padding: 3.25em 10em;
    margin: 0.75em 0;
  }

  .header-container {
    margin-bottom: 1em;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }

  .data-container {
    justify-content: space-between;
  }
  .text-container {
    color: ${color.lightishGray};
    font-family: ${fontTypes.meduim};
  }
  .bx-shadow-none {
    box-shadow: none;
  }
  .react-multiple-carousel__arrow {
    background: ${color.white};
    box-shadow: ${color.buttonShadow};
    z-index: 2;
  }
  .react-multiple-carousel__arrow--right::before,
  .react-multiple-carousel__arrow--left::before {
    color: ${color.red};
  }
`;

export const feeContainerStyles = css`
  .card-container {
    max-width: none;
    background-color: ${color.whitishGray};
  }
  .payment-service-type {
    text-align: left;
    margin-bottom: 15px;
    margin-right: 1em;
  }
  .payment-service-type-section {
    margin-bottom: 2em;
  }
`;
